import { z } from 'zod';

export const CreateApplicationResultSchema = z.object({
  code: z.number(),
  message: z.string(),
});

export type CreateApplicationResult = z.infer<
  typeof CreateApplicationResultSchema
>;

export interface CreateApplicationParams {
  currency: string;
}
